import { styled } from "@mui/material/styles";
import { Card, Grow } from "@mui/material";
import * as L from "leaflet";

import { LayerManagerContext } from "src/types";
import { LayersListSkeleton, LayersList } from "./LayersList";
import { ActiveLayers } from "./ActiveLayers";
import { Suspense } from "react";

interface Props {
  map: L.Map;
  open: boolean;
  context: LayerManagerContext;
}

export function LayerManager(props: Props) {
  return render();

  function render() {
    return (
      <Styles>
        <Grow in={props.open} style={{ transformOrigin: "top right" }} unmountOnExit>
          <Card className="root-wrapper">
            <Suspense fallback={<LayersListSkeleton />}>
              <LayersList context={props.context} />
            </Suspense>
            <ActiveLayers map={props.map} context={props.context} />
          </Card>
        </Grow>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  --layer-manager-width: 240px;
  position: relative;
  .MuiCollapse-root {
    height: 100%;
  }
  .root-wrapper {
    height: calc(100vh - 100px);

    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 100%;
    top: 0;
    left: 0;
    width: var(--layer-manager-width);
    flex-direction: column;
  }

  .MuiCollapse-wrapper {
    overflow: auto;
  }
`;
